webpackJsonp([267937933260274],{

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dms-screen-desktop.b419d074.jpg";

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4KICA8cGF0aAogICAgICBmaWxsPSIjRDkzMDIzIgogICAgICBkPSJNMjAwLjggMTU3LjJsLTM2LjQgMzcuNEw0MTEuNyA0NDhsMzYuMy0zNy40ek0xODEgNjRoMzd2NjhoLTM3ek0xODEgMjYyaDM3djY4aC0zN3pNMjcwIDE3Nmg2OXYzN2gtNjl6TTMwNS42IDExNS44bC0yNS43LTI2LjMtNDcuMSA0OC4zIDI1LjYgMjYuMnpNMTY4LjggMTM3LjhsLTQ3LjEtNDguMy0yNS42IDI2LjMgNDcuMSA0OC4yek05Ni4xIDI3Ny45bDI1LjYgMjYuMiA0Ny4xLTQ4LjItMjUuNi0yNi4zek02NCAxNzZoNjV2MzdINjR6Ii8+Cjwvc3ZnPg=="

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CaseFirstScreenArea = __webpack_require__(23);
	
	var _CaseFirstScreenArea2 = _interopRequireDefault(_CaseFirstScreenArea);
	
	var _Sharing = __webpack_require__(20);
	
	var _Sharing2 = _interopRequireDefault(_Sharing);
	
	var _ContactUs = __webpack_require__(24);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	var _SpecialTitle = __webpack_require__(60);
	
	var _SpecialTitle2 = _interopRequireDefault(_SpecialTitle);
	
	__webpack_require__(614);
	
	var _dmsScreenDesktop = __webpack_require__(723);
	
	var _dmsScreenDesktop2 = _interopRequireDefault(_dmsScreenDesktop);
	
	var _mdColorWand = __webpack_require__(724);
	
	var _mdColorWand2 = _interopRequireDefault(_mdColorWand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentHost = typeof window !== 'undefined' ? window.location.origin : '';
	var metaTitle = 'Document Management System | Product Specification Management and PSM Program Development Service';
	var metaDiscrip = 'Looking for a company to order Web APP with special requirements? Codenetix team is definitely right choice. Call us today ☎ +7 903 983 3020 if you really liked this client project and order the same one tailor-made web app at best price!';
	var metaImg = currentHost + '/img/cases/dms-sharing.png';
	var metaUrl = currentHost + '/cases/dms';
	var metaTags = [{ name: 'description', content: metaDiscrip }, { name: 'keywords', content: 'codenetix software b2b integration web' }, { name: 'author', content: 'CODENETIX' }, { name: 'image', content: '' + metaImg }, { name: 'twitter:title', content: metaTitle }, { name: 'twitter:description', content: metaDiscrip.substr(0, 200) + '...' }, { name: 'twitter:image', content: metaImg }, { name: 'twitter:url', content: metaUrl }, { itemprop: 'name', content: metaTitle }, { itemprop: 'description', content: metaDiscrip }, { itemprop: 'image', content: '' + metaImg }, { property: 'og:title', content: metaTitle }, { property: 'og:type', content: 'article' }, { property: 'og:description', content: metaDiscrip.substr(0, 200) + '...' }, { property: 'og:url', content: metaUrl }, { property: 'og:image', content: metaImg }];
	
	var CaseDMS = function CaseDMS() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'cx-main case-page case-dms' },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: metaTitle,
	        meta: metaTags
	      }),
	      _react2.default.createElement(_CaseFirstScreenArea2.default, {
	        companyName: 'Document Management System',
	        caseDenotation: 'Product Specification Management',
	        screens: { iMac: { image: _dmsScreenDesktop2.default } },
	        demoType: 'desktop'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'case-description cx-box' },
	        _react2.default.createElement(_SpecialTitle2.default, {
	          beginning: 'Lean IT Solutions Help Customer',
	          ending: 'Cut Costs On Procurement',
	          iconImg: _mdColorWand2.default
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement('div', { className: 'cx-gap-3' }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Centralizing Procurement in a Multinational Company Becomes a Challenge for IT Budget'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'By centralizing procurement function in a large multinational company with high M&A activity, one should expect a good return: not only centralizing leads to a larger purchase volume and better discount from suppliers, but unification of product specifications decreases need of working capital due to smaller amount of different raw materials needed to be on-stock.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Food Union, a dairy-producing enterprise spanned across Europe, Russia and Eastern Asia, and a valued Client of Codenetix, was in the beginning of that path in 2017. Deployment of PSM (Product Specification Management) solution became an essential part of IT landscape as procurement centers responsible for specific materials were established across Food Union production sites, with BOM (bill of materials) unification as one of their main tasks.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'First, a large amount of enterprise PSM solutions have been evaluated and put into comparison. Large number of features mark almost every commercial product on the market. However, extensive feature list has its flip side: enterprise-level PSM systems are complex in deployment and pricey. Long list of features means more complex set up and longer learning curve for end users. Adding to that, implementation costs of $30K+ and maintenance of at least $5K per year make them a choice for really big enterprises.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Tailor-Made Web App as a Working Solution'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'With all that given, the task for a Codenetix team was really challenging: to offer a product that should be more user friendly (as user base is distributed among procurement centers in several countries, so zero time invested in user training is a must), web-based (no installation, no corporate LAN), cover all features needed for a Customer team, and, finally, be less expensive than corporate out-of-the-box solutions.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Strict adherence to agile methodology and strong teams both on Customer and Codenetix sides made this possible. Thorough prioritisation and cutting away unneeded features, using of cutting-edge development tools and frameworks, TDD (test driven development) made development speed truly amazing.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Web app was released in under than three months, but went live just way before, just after first month of development \u2013 a database and data management interface was ready as MVP, and \xABpilot\xBB team, which manages sticks for ice cream, started using the product right away. Other features came in short notice, which allowed whole Customer team to collaborate and manage their data in new environment.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'As reported, Food Union have already gained substantial cost savings by implementing new procurement practices. Codenetix team is happy to help our Customer in gaining these results, supporting future growth.'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'cx-gap-1' })
	      ),
	      _react2.default.createElement(_Sharing2.default, {
	        shareUrl: metaUrl,
	        title: metaTitle,
	        image: metaImg
	      }),
	      _react2.default.createElement('div', { className: 'cx-gap-3' }),
	      _react2.default.createElement(_ContactUs2.default, { title: 'Want a similar project?', subtitle: 'Drop us a line to chat about it' })
	    )
	  );
	};
	
	exports.default = CaseDMS;
	module.exports = exports['default'];

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cases-dms-index-jsx-154ec7c72bc7f1a77187.js